import { render, staticRenderFns } from "./florist-update.vue?vue&type=template&id=65c0ff81"
import script from "./florist-update.vue?vue&type=script&lang=js"
export * from "./florist-update.vue?vue&type=script&lang=js"
import style0 from "./florist-update.vue?vue&type=style&index=0&id=65c0ff81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports